const $ = jQuery;
const $window = $(window);

const initMobileMenuOverlay = () => {
  const $navToggle = $('.main-nav-bar-icon');
  const $offcanvasMobile = $('.om-header-mobile-offcanvas');
  const $closeElements = $('.main-nav-close-icon, .om-header-mobile-overlay');
  const $body = $('body');

  $navToggle.on('click', (event) => {
    event.preventDefault();
    $body.addClass('om-nav-active');
    $offcanvasMobile.addClass('open');
  });

  $closeElements.on('click', (event) => {
    event.preventDefault();
    $body.removeClass('om-nav-active');
    $offcanvasMobile.removeClass('open');
  });
};

$window.on('load', () => initMobileMenuOverlay());

function moveElementsOnBreakpoint() {
  const breakpoint = 1440; // Desktop breakpoint
  const mobileContainer = document.querySelector(
    '.om-header-mobile-offcanvas__body',
  );
  const desktopContainer = document.querySelector('.oh-main-nav');
  const elementsToMove = document.querySelectorAll('.on-col');

  if (window.innerWidth >= breakpoint) {
    // Move elements to desktop container
    elementsToMove.forEach((element) => {
      desktopContainer.insertAdjacentElement('afterend', element);
    });
  } else {
    let activeTrail = null;
    // Move elements to mobile container
    elementsToMove.forEach((element) => {
      mobileContainer.appendChild(element);

      const dropdownControl = element.querySelector('.on-dropdown-control');

      if (
        dropdownControl?.classList.contains(
          'on-dropdown-control-mobile-toggle-active',
        )
      ) {
        activeTrail = dropdownControl;
      }
    });

    // Open dropdown on mobile for active trail.
    if (activeTrail) {
      activeTrail.click();
    }
  }
}

// Call the function on window resize and initial load
window.addEventListener('resize', moveElementsOnBreakpoint);
moveElementsOnBreakpoint();
